/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {IContractDto} from '../Contract.model'
import { useIntl } from 'react-intl'
import classNames from 'classnames'
import { IconLabelContent } from '../../../common/component/IconLabelContent'

interface Props {
  disabled?: boolean
  data: IContractDto
  rowSelected?: string
  backgroundClass?: string
  hoverBackgroundClass?: string
  onRowClick?: (id: string) => void
  removeOnClick?: (id: string) => void
}

const ContractListItem: FC<Props> = ({
  disabled,
  data,
  rowSelected,
  backgroundClass = 'bg-light-primary',
  hoverBackgroundClass = 'bg-hover-light-primary',
  onRowClick,
  removeOnClick,
}: Props) => {
  const intl = useIntl()
  const backGroundClasses = {}
  backGroundClasses[`d-flex flex-stack py-2 ${backgroundClass}`] = data.id === rowSelected

  const hoverBackGroundClasses = {}
  hoverBackGroundClasses[`d-flex flex-stack py-2 ${hoverBackgroundClass}`] = data.id !== rowSelected

  const buildDescriptionLine = (data: IContractDto) => {
    let description = ``
    if (data.client?.displayName) {
      description += description ? ` | ${data.client?.displayName}` : `${data.client?.displayName}`
    }
    if (data.serviceType) {
      description += description ? ` | ${data.serviceType}` : `${data.serviceType}`
    }
    if (data.serviceFrequency) {
      description += description ? ` | ${data.serviceFrequency}` : `${data.serviceFrequency}`
    }
    if (data.serviceLocation) {
      description += description ? ` | ${data.serviceLocation}` : `${data.serviceLocation}`
    }

    return description
  }

  const builStatusLine = (data: IContractDto) => {
    return `${intl.formatMessage({id: `UTIL.STATUS.${data.status}`})} | ${new Date(data.startDate).toISOString().split('T')[0]} - ${
          new Date(data.endDate).toISOString().split('T')[0]
        }`
  }

  return (
    <div
      className={classNames(backGroundClasses, hoverBackGroundClasses)}
      onClick={() => onRowClick && onRowClick(data.id)}
    >
      <div className='d-flex flex-stack'>
        <div className='d-flex align-items-center'>
          {!disabled && removeOnClick && (
            <div className='row'>
              <div className='d-flex justify-content-end align-items-center'>
                <button
                  type='button'
                  className='btn btn-sm btn-icon'
                  onClick={() => removeOnClick(data.id)}
                >
                  <i className='bi bi-x fs-1 fw-bold text-danger'></i>
                </button>
              </div>
            </div>
          )}

          <div className='ms-2'>
            <div className='fs-7'>
              <span className='fw-bolder mb-2'>{`${data.documentType}`}</span>
              <span className='text-gray-600 ms-2 me-2 mb-2'>-</span>
              <span className='text-primary mb-2'>{data.sequence}</span>
            </div>

            <div className='d-flex justify-content-start'>
              <div className='d-flex align-items-center fs-8'>
                <span className='text-gray-600'>{buildDescriptionLine(data)}</span>
              </div>
            </div>

            <div className='d-flex justify-content-start align-items-center'>
              <IconLabelContent
                title={builStatusLine(data)}
                active={data.status === 'ACTIVE'}
                icon={`${data.status === 'ACTIVE' ? 'bi bi-calendar2-check' : 'bi bi-calendar2-x'}`}
                inactiveColor='text-danger'
              />

              <IconLabelContent
                title={
                  data.totalAttachment > 0
                    ? intl
                        .formatMessage({
                          id:
                            data.totalAttachment === 1
                              ? 'TITLE.ATTACHMENT.TOTAL_SINGLE'
                              : 'TITLE.ATTACHMENT.TOTAL_MULTIPLE',
                        })
                        .replace(/%s/g, `${data.totalAttachment}`)
                    : intl.formatMessage({id: 'TITLE.ATTACHMENT.ZERO'})
                }
                active={data.totalAttachment > 0}
                labelValue={`${data.totalAttachment || 0}`}
                icon='bi bi-paperclip'
              />

              <IconLabelContent
                title={`${intl
                  .formatMessage({id: 'TITLE.ASSET.TOTAL'})
                  .replace(/%s/g, `${data.totalAsset > 0 ? data.totalAsset : 0}`)}`}
                labelValue={`${data.totalAsset || 0}`}
                active={data.totalAsset > 0}
                icon='bi bi-cpu'
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export {ContractListItem}
